/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { useEffect } from 'react';

const useBodyScrollLock = (trigger: boolean) => {
  const lockBody = () => {
    const body = document.querySelector('body');

    if (body?.style) {
      body.style.overflow = 'hidden';
    }
  };

  const unlockBody = () => {
    const body = document.querySelector('body');

    if (body?.style) {
      body.style.overflow = '';
    }
  };

  useEffect(() => {
    if (trigger) {
      lockBody();
    } else {
      unlockBody();
    }

    return () => {
      unlockBody();
    };
  }, [trigger]);
};

export { useBodyScrollLock };
